import { PlatePluginOptions } from '@udecode/plate-core';

export const MARK_CODE = 'code';

export const DEFAULTS_CODE: Partial<PlatePluginOptions> = {
  hotkey: 'mod+e',
};
